import { render } from "./BusinessDashboard.vue?vue&type=template&id=bc73fe78&scoped=true"
const script = {}

import "./BusinessDashboard.vue?vue&type=style&index=0&id=bc73fe78&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc73fe78"]])

export default __exports__